import { TextField, Box, FormGroup, FormHelperText, FormLabel, Checkbox, FormControlLabel } from "@mui/material";
import React from "react";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../../../../../app/hooks";
import { IncidentTypeDetail } from "../../../../../../services/varianceService/model/varianceRequest/IncidentTypeDetail";
import { editIncidentTypeDetails } from "../../../../../../services/varianceService/model/varianceRequest/VarianceRequestSlice";
import { MedicationEventOptions } from "./MedicationEventOptions";

function MedicationEventDetails() {
  const dispatch = useDispatch();
  const incidentTypeDetails = useAppSelector(
    (state) => state.varianceRequest.varianceRequest.incidentTypeDetails
  );
  const MedOptionTypes: IncidentTypeDetail[] = MedicationEventOptions.map((option) => ({
    name: option.name,
    checked: incidentTypeDetails.find((x) => x.name === option.name)?.checked ?? false,
    description: option.description,
    incidentType: "MEDICATION",
    subTypeDetails: [],
  }));
  const [MedOptions, setMedOptions] = React.useState({ MedOptionTypes });
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const incidentTypeDetail: IncidentTypeDetail = {
      name: event.target.name,
      checked: event.target.checked,
      description:
        (event.target.labels && event.target.labels[0]?.textContent) || "",
      incidentType: "MEDICATION"
    };
    setMedOptions((prevOptions) => ({
      ...prevOptions,
      MedOptionTypes: prevOptions.MedOptionTypes.map((option) =>
        option.name === event.target.name
          ? { ...option, checked: event.target.checked }
          : option
      ),
    }));
    dispatch(editIncidentTypeDetails(incidentTypeDetail));
  };
  const [freeForm, setFreeForm] = React.useState(incidentTypeDetails?.find((x) => x.name === "MEDFREEFORM")?.description); 
  const setOther = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const incidentTypeDetail: IncidentTypeDetail = {
        name: "MEDFREEFORM",
        checked: true,
        description: event.target.value,
        incidentType: "MEDICATION"
      };
      setFreeForm(incidentTypeDetail.description);
      dispatch(editIncidentTypeDetails(incidentTypeDetail));
  }

  return (
    <React.Fragment>      
      <Box mt={2} mb={2} sx={{ display: "flex", flexDirection: "column", ml: 3, mr: 3 }}>
        <FormHelperText>Select One or More</FormHelperText>
        <FormLabel component="legend">Medication Event Details</FormLabel>
        <FormGroup sx={{ height: "500px" }}>
          {MedOptions.MedOptionTypes.map((value) => (
            <FormControlLabel
              key={value.name}
              label={value.description}
              control={
                <Checkbox
                  checked={value.checked}
                  name={value.name}
                  onChange={(e) =>
                    handleChange(e)
                  }
                />
              }
            />
          ))}
           <TextField id="standard-basic" name="MEDFREEFORM" label="Other" variant="standard" value={freeForm} onChange={setOther}/>
        </FormGroup>
      </Box>
    </React.Fragment>
  );
};

export {MedicationEventDetails};
